<i18n lang='yml' src='../i18n/BookingTrainingPrograms.yml'></i18n>
<template>
  <div v-if="active">
    <flash :message_type="messageType" :message_text="messageText"/>
    <h6 class="margin-top heading-page">
      {{$t('exam_resources')}} 
    </h6> 
    <alert custom_class="help-block" :show_icon="true" :alert_text="$t('resource_text', { resourceLink })"/>

    <h5 class="margin-top heading-page">
      {{$t('book_exam_section')}}
    </h5>

    <span v-if="admin == 'false'" v-html="$t('challenger_accommodation_guiding_text')"/>

    <p> {{$t('book_exam_guiding_text', {type: details.user_name})}}</p>
    <div class="media-list exam-list">
      <div v-for="item in eligibleTrades" :key="item.id">
        <ul v-if="item" class="list-inline list-annotation">
          <li>
            <h5 class="exam-item-name">
              {{item.full_name}}
            </h5>
          </li>
          <li class="ml-auto">
            <div class="btn-group btn-group-sm ml-auto" role="group">
              <button :disabled="item.eligibility && !item.eligibility.eligible" @click="nextStep(item)" class="btn btn-success btn-sm pullright">
                {{$t('book_exam')}}
              </button>
            </div>
          </li>
          <li class="w-100" v-if="item.eligibility && !item.eligibility.reason && admin == 'true' && !item.eligibility.credit_available">
            <alert custom_class="help-block" :show_icon="true" :alert_text="$t('fee_not_paid')"/>
          </li>
          <li class="w-100" v-if="item.eligibility && item.eligibility.reason"> 
            <alert custom_class="help-block" :show_icon="true" :alert_text="$t(item.eligibility.reason, {date: formatDate(item.eligibility.date)})"/>
          </li>
        </ul> 
      </div>
      <span v-if="eligibleTrades.length == 0" v-html="$t('no_eligible_trades')"/>
    </div> 
    <h6 class="margin-top heading-page" id="bookingTableTitle">
      {{$t('exam_booking_section')}}
    </h6>
    <p> {{$t('booking_guiding_text')}} </p>

    <scroll-shadow>
      <div class="table-container" id="table-container-booking" role="table" aria-describedby="bookingTableTitle">
        <div class="flex-table-booking" role="rowgroup">
          <div class="flex-row flex-row-long table-header" role="columnheader">{{$t('columns.trade')}}</div>
          <div class="flex-row flex-row-short table-header" role="columnheader">{{$t('columns.exam_date')}}</div>
          <div class="flex-row flex-row-short table-header" role="columnheader">{{$t('columns.start_time')}}</div>
          <div class="flex-row table-header" role="columnheader">{{$t('columns.location')}}</div>
          <div class="flex-row table-header" role="columnheader">{{$t('columns.status')}}</div>
          <div class="flex-row flex-row-smaller table-header" role="columnheader">{{$t('columns.actions.column_text')}}</div>
        </div>
        <div v-if="active && loading">
          <loading-animation-vue :spinnerSize="40"></loading-animation-vue>
        </div>
        <div v-else-if="bookings.length > 0">
      
          <div class="fill-table" v-for="item in bookings" :key="item.id">
            <div class="flex-table-booking" role="rowgroup">

              <div class="flex-row flex-row-long first" role="cell">        
                {{item.training_program.full_name}}
              </div>
               
              <div class="flex-row flex-row-stretch" role="cell"> 
                <template v-for="(sitting, index) in item.sittings" :key="sitting.id">   
                  <div class="d-flex">
                  <div class="flex-row flex-row-short" :class="getRowStyle(item.sittings, index)" >
                    {{formatDate(sitting.date)}}
                  </div>
                  <div class="flex-row flex-row-short" :class="getRowStyle(item.sittings, index)">
                    {{formatTime(sitting.start_time)}}
                  </div>

                  <div class="flex-row" :class="getRowStyle(item.sittings, index)">
                    {{sitting.sub_location.name[locale]}}
                  </div>
                  </div>
                </template> 
              </div>
    
              <div class="flex-row" role="cell">        
                {{$t(`columns.statuses.${item.status}`)}}
              </div>
              <div class="flex-row flex-row-smaller" role="cell">   
                <div class="dropdown">
                  <button class="dropdown-toggle btn btn-sm btn-outline-secondary" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <font-awesome-icon :icon="['fa', 'cog']"/>
                    <span class="sr-only">{{$t('toggle_dropdown')}}</span>
                  </button>
                  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <a class="dropdown-item" @click.prevent="showBookingDetails(item.id)" href="#">{{$t('details') }}</a>
                    <a v-if="modifyingRequirements(item.status) && admin == 'true'" :href="`${base_path}/${item.id}/edit`" class="dropdown-item">
                      {{$t('columns.actions.edit') }} 
                    </a>
                    <a v-if="modifyingRequirements(item.status) && admin == 'false'" @click.prevent="cancelBooking(item)" 

                    class="dropdown-item" href="#">
                      {{$t('columns.actions.cancel') }} 
                    </a>
                    <a v-else-if="cancelRequirements(item.status) && admin == 'true'" @click.prevent="showComments(item.id)" class="dropdown-item">
                      {{$t('columns.actions.cancel') }} 
                    </a>
                    <a v-else-if="item.status == 'passed' || item.status == 'failed'" @click.prevent="showBookingResults(item)" class="dropdown-item" href="#">{{$t('columns.actions.results') }}</a>
                  </div>
                </div>
              </div>
            </div>
            
            <div v-if="openDetails == item.id" role="rowgroup" >

              <div class="flex-row-full" role="rowgroup">
                <div class="d-flex mb-2">
                  <p class="status-bold" for="comment"> {{ $t('exam_details') }} </p>
                  <button @click="showBookingDetails(item.id)" class="ml-auto btn btn-light btn-sm">
                    {{$t('close') }}
                  </button>
                </div>
                <div v-for="(sitting, index ) in item.sittings" :key="sitting.id">

                  <h6 :key="sitting.id" v-if="item.sittings.length > 1">
                    {{`${$t('session')} ${index+1}`}}
                  </h6>
   
                  <div class="details-table">
                    <div class="flex-row flex-row-short">
                      <span class="status-bold w-100">
                        {{$t('end_time') }}
                      </span>
                      <span>{{`${formatTime(sitting.end_time)}`}}</span>
                    </div>
                    <div class="flex-row">
                      <span class="status-bold w-100">
                        {{$t('time_allowance') }}
                      </span>
                      <span>{{item.exam_type.time_allowance}} {{$t('hours') }}</span>
                    </div>
                    <div class="flex-row flex-row-short">
                      <span class="status-bold w-100">
                        {{$t('exam_type') }}
                      </span>
                      <span>{{`${item.exam_type.name[locale]}`}}</span>
                    </div>
                    <div class="flex-row flex-row-long" v-if="item.booking_accommodations.length > 0">
                      <span class="status-bold w-100">
                        {{$t('accommodations')}}
                      </span>
                      <span v-for="accommodation in item.booking_accommodations" :key="accommodation.id">
                        {{`${$t(accommodation.accommodation_type)} - ${$t(accommodation.status)}`}}<br>
                      </span>
                    </div>
                    <div v-if="item.sir_id" class="flex-row flex-row-long">
                      <span class="status-bold w-100">
                        {{$t('sir_information')}}
                      </span>
                      <span>
                        {{`${item.sir_id} - ${item.sir_name}`}}
                      </span>
                    </div>
                    <div class="flex-row flex-row-long">
                      <span class="status-bold w-100">
                        {{$t('exam_location_address') }}
                      </span>
                      <p class="address-span">
                      <span>{{`${sitting.sub_location.street_address},`}}</span>
                      <span>{{`${sitting.sub_location.city}, ${sitting.sub_location.province},`}} </span><span>{{`${sitting.sub_location.postal_code}`}}
                        </span>
                        </p>
                    </div>
                    <div class="flex-row flex-row-long">
                      <span class="status-bold d-block w-100">
                        {{$t('exam_location_info') }}
                      </span>
                      <span class="w-100 d-block ">{{$t('phone_number')}}:</span>
                      <span> {{`${sitting.sub_location.phone_number}`}}</span>
                      <span  class="w-100 d-block ">{{$t('email')}}:</span>
                      <span> {{`${sitting.sub_location.email}`}}</span>
                    </div>
                  </div>
                </div>
                <p class="status-bold" for="comment"> {{ $t('exam_status_history') }} </p>
                <history-table :locale="locale" name="booking" :itemData="tableData(item)" :column_info="columnData()"/>
              </div>
            </div>

            <div class="flex-table-booking" v-if="commentsItem == item.id" role="rowgroup" > 
              <div class="flex-row-full" role="cell">
                <div class="d-flex mb-2">
                  <label for="comment"> {{ $t('comments') }} </label>
                  <button @click="showComments(item.id)" class="ml-auto btn btn-light btn-sm">
                    {{$t('close') }}
                  </button>
                </div>
                <div class="comments_section">
                  <textarea class="textareaComments" v-model="commentText" cols="70"/>
                </div>
                <div class="d-flex">
                  <a class="btn btn-danger ml-auto" href="#"  @click.prevent="cancelBooking(item)">
                    {{$t('columns.actions.cancel') }} 
                  </a>
                </div>
              </div>
            </div>
          </div>
  
        </div>

        
        <div v-else>
          <div class="fill-table">
            <div class="flex-table-booking">
                <span class="p-3"> 
                  {{$t('no_booking_data')}} 
                </span>
              </div>
            </div>
          </div>
      </div>
    </scroll-shadow>

    <div v-if="resultsItem && Object.keys(resultsItem.results).length > 0">
      <div class="flex-table-booking" role="rowgroup">
        <div class="flex-row-full" role="cell">
          <div class="d-flex mb-2">
            <p class="status-bold" for="comment"> {{ $t('results') }} - {{$t(`columns.statuses.${resultsItem.status}`)}}</p>
            <button @click="showBookingDetails(sitting.id)" class="ml-auto btn btn-light btn-sm">
              {{$t('cancel') }}
            </button>
          </div>

          
          <ul class="exam-details my-4">
            <li>
              <span class="status-bold">
                {{$t('exam_name')}}
              </span>
              {{`${resultsItem.training_program.trade_code} - ${resultsItem.training_program.name[locale]} - ${resultsItem.exam_type.name[locale]}`}}
            </li>
            <li>
              <span class="status-bold">
                {{$t('scheduled_date')}}
              </span>
              {{formatDate(resultsItem.sittings[0].date)}}
            </li>
            <li>
              <span class="status-bold">
                {{$t('exam_location')}}
              </span>
              {{resultsItem.sittings[0].sub_location.name[locale]}}
            </li>
            <li>
              <span class="status-bold">
                {{$t('percentage_earned')}}
              </span>
              {{resultsItem.results.total_percent}}
            </li>
            <li>
              <span class="status-bold">
                {{$t('percentage_required')}}
              </span>
              {{resultsItem.exam_type.pass_mark}}
            </li>
          </ul>
        </div>
      </div>
      <scroll-shadow>
        <div class="table-container" id="table-container-booking" role="table" aria-describedby="historyTableTitle">
          <div class="flex-table-booking" role="rowgroup">
            <div class="flex-row-long table-header" role="columnheader">{{$t('section_name')}}</div>
            <div class="flex-row-long table-header" role="columnheader">{{$t('max_score')}}</div>
            <div class="flex-row-long table-header" role="columnheader">{{$t('your_score')}}</div>
          </div>
        </div>
      </scroll-shadow>
        
        <div class="fill-table">
          <div :key="section" v-for="(section, index) in resultsItem.results.results.section_names" class="flex-table-booking" role="rowgroup" >
            <div class="flex-row-long" role="cell">
              {{section}}
            </div>
            <div class="flex-row-long" role="cell">        
              {{resultsItem.results.results.maximum_score[index]}}
            </div>
            <div class="flex-row-long" role="cell">        
              {{resultsItem.results.results.score[index]}}
            </div>
          </div>

          <div class="flex-table-booking" role="rowgroup" >
            <div class="flex-row-long" role="cell">        
              {{$t('total')}}
            </div>
            <div class="flex-row-long" role="cell">        
              {{total(resultsItem.results.results.maximum_score)}}
            </div>
            <div class="flex-row-long" role="cell">        
              {{total(resultsItem.results.results.score)}}
            </div>
          </div>
        </div>

    </div>

  </div>
</template>  
<script>
  import table_top_nav from '../../../shared/table_top_nav/TableTopNav.vue';
  import flash from '../../../shared/flash_messages/components/Flash.vue';
  import Table from '../../../shared/table/components/Table.vue'
  import LoadingAnimation from '../../../shared/loader/components/LoadingAnimation.vue';
  import {formatDate, formatTime} from '../../../shared/typescripts/dates.ts'
  import alert from '../../../shared/alerts/AlertsInfo.vue';

  export default {
    components: { table_top_nav, flash, 'history-table': Table , 'loading-animation': LoadingAnimation, alert},
    props: ['locale', 'base_path', 'details', 'active', 'admin', 'english_resources_link', 'french_resources_link', 'time_format_en', 'time_format_fr'],

    data() {
      return {
        loading: true,
        bookings: [],
        error: false,
        eligibleTrades: [],
        messageText: [],
        messageType: "",
        openDetails: 0,
        resultsItem: null,
        commentsItem: 0,
        commentText: null,
      }
    },
    watch: {
      async active(newVal) {
        if(newVal) {
          this.$i18n.locale = this.locale;
          await this.sendAjaxRequest('GET', `${this.base_path}/update_user_accommodations`, {user_identity_id: this.details.user_identity_id})
          await this.sendAjaxRequest('GET', `${this.base_path}`, {user_identity_id: this.details.user_identity_id}, this.setBookings)
          await this.sendAjaxRequest('GET', `${this.base_path}/eligible_training_programs`, {user_identity_id: this.details.user_identity_id}, this.setTrainingPrograms)
        }
      },
    },
    computed: {
      resourceLink() {
        return this.locale === 'en' ? this.english_resources_link : this.french_resources_link;
      }
    },
    methods: {
    // For each item row in the table, pulls out the data necessary from the item and stores it in keys that are referenced in columnData function
    tableData(item) {
      return item && item.versions.length > 0 ? item.versions.map((version) => {
        return {
          created_at: version.created_at, 
          full_name: version.user_identity ? `${version.user_identity.first_name} ${version.user_identity.last_name}` : '',
          status: this.$i18n.t(`columns.statuses.${version.current_status}`),
          notes: this.$i18n.t(`${version.current_comment}`)
        }
      }) : []
    },
    //Returns the sum of an array of strings
    total(values) {
      let total = 0
      values.forEach((value) => {
        total += parseInt(value)
      })
      return total
    },

    // Returns an array of objects, each representing a column in the table with a column name, a key for the attribute it pulls from and a format type
    columnData() {
      let columns = [
        {name: this.$i18n.t('status'), key: 'status'},
        {name: this.$i18n.t('status_date'), key: 'created_at', formatType: 'date'},
        {name: this.$i18n.t('change_by'), key: 'full_name'},
        {name: this.$i18n.t('notes'), key: 'notes'},
      ]
      return columns
    },
    formatTime: function (date) {
      let format = this.locale == 'en' ? this.time_format_en : this.time_format_fr
      return formatTime(date, format)
    },
    formatDate(dateString) {
      return formatDate(dateString)
    },
    setTrainingPrograms(data) {
      this.eligibleTrades = data.eligibility
      this.$emit('userEligibility', data.eligibility)
    },
    setBookings(data) {
      data.map((booking) => {booking.versions.reverse()})
      this.bookings = data
      this.loading = false
    },
    nextStep(trainingProgram, $event) {
      this.$emit('trainingProgramChange', {
        'training_program_id': trainingProgram.id, 
        'training_program_full_name': trainingProgram.full_name
      })
      this.$emit('nextStep')
    },

    async sendAjaxRequest(method, url, data, success) {
      $.ajax({
        type: method,
        url: `${url}.json`,
        data_type: 'json',
        data: data,
        success: success,
        error(message) {
          console.log(message);
        }
      });
    },

    scrollToTop() {
      window.scrollTo({top: 0, behavior: 'smooth'});
    },

    showBookingDetails(id) {
      id === this.openDetails ? this.openDetails = 0 : this.openDetails = id;
    },

    showComments(id){
      id === this.commentsItem ? this.commentsItem = 0 : this.commentsItem = id
    },

    showBookingResults(item) {
      item === this.resultsItem ? this.resultsItem = null : this.resultsItem = item;
    },

    /// - Cancellation Methods - ///
    modifyingRequirements(status){
      if(status != 'passed' && status != 'failed' && status != 'cancelled' && status != 'results_pending'){
        return true
      }
    },

    /// - Cancellation Methods - ///
    cancelRequirements(status, admin){
      if(status != 'passed' && status != 'failed' && status != 'cancelled' || (admin && status == 'results_pending')){
        return true
      }
    },

    cancelBooking(booking) {
      if (!confirm(this.$t('confirm_cancel'))) {
        return
      }
      let bookingData = booking
      bookingData.booking_id = booking.id
      bookingData.sitting_id =  ''
      booking.comment = this.commentText;
      this.sendAjaxRequest('POST', `${this.base_path}/cancel_booking`, {booking: booking}, this.cancelSuccess)
    },

    cancelSuccess(data) {
      this.messageText = []
      this.messageText.push(data.message)
      this.messageType = 'notice'
      this.sendAjaxRequest('GET', `${this.base_path}`, {user_identity_id: this.details.user_identity_id}, this.setBookings)
      this.sendAjaxRequest('GET', `${this.base_path}/eligible_training_programs`, {user_identity_id: this.details.user_identity_id}, this.setTrainingPrograms)
      this.commentsItem = ''
      this.scrollToTop()
    },

    getRowStyle(sittings, index){
      return sittings.length > 1 && index + 1 !== sittings.length ? 'flex-border-bottom' : ''
   }
  }
}
</script>
